import React from 'react';
import { ConnectedGeoLocationSelector } from './GeoLocationSelector';
import { Config, LocalStorageUtils, LocationUtils } from '../../utils';

export function GeoLocationSource() {
    const isNotAllowed = LocalStorageUtils.getJSON('geoLocAllowed') !== null;
    return {
        render: ({ onClickItem, displayedWord, activeProduct } = {}) => {
            return (
                <ConnectedGeoLocationSelector
                    show={
                        !LocationUtils.isKeywordLongEnoughAccordingWithLanguage(
                            displayedWord,
                            Config.get('autocompleteOptions'),
                            activeProduct,
                        ) && !isNotAllowed
                    }
                    key="geo-locations"
                    onClickItem={onClickItem}
                    activeProduct={activeProduct}
                />
            );
        },
    };
}
